package components.items

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 13.10.22
 * Author : marcusspors
 */

import core.AppContext
import core.enums.EImages
import core.ionic.IonButton
import csstype.Position
import csstype.px
import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.span
import react.router.Navigate
import react.useContext
import react.useMemo
import react.useState
import screens.EScreens


external interface ProductlistIconProps : Props {
    var mIsActive: Boolean
}

val ProductlistIcon = FC<ProductlistIconProps> { props ->

    val mIsActive = props.mIsActive
    val mContext by useContext(AppContext)
    val mCount = useMemo(mContext) {
        mContext.mLocalStorageReducer.component1().mProductList.count()
    }

    //val mIsListEmpty = useMemo(mContext) {mContext.mLocalStorageReducer.component1().mProductList.isEmpty()}
    val mSrc = useMemo(mIsActive) {
        if (mIsActive) EImages.SHOPPING_CART_ICON(
            EImages.EColor.BLACK,
            EImages.EType.FILLED
        ).mRelativePath
        else EImages.SHOPPING_CART_ICON(EImages.EColor.BLACK, EImages.EType.OUTLINED).mRelativePath
    }


    var mNavigation: String? by useState(null)

    ReactHTML.div {
        css {
            position = Position.relative
        }

        IonButton {
            fill = "clear"
            img {
                css {
                    height = 24.px
                }
                src = mSrc

            }
            onClick = {
                if (!mIsActive) {
                    mNavigation = EScreens.PRODUCT_LIST_SCREEN.mPath
                }
            }
        }

        if (mCount > 0) {
            span {
                css {
                    position = Position.absolute
                    top = 8.px
                    right = 42.px
                }
                +"$mCount"
            }
        }
    }

    mNavigation?.let {
        Navigate {
            to = it
        }
    }

}
